import { render, staticRenderFns } from "./WorkflowDialog.vue?vue&type=template&id=71bf729e"
import script from "./WorkflowDialog.vue?vue&type=script&lang=js"
export * from "./WorkflowDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports